import moment from 'moment'

export const toInquiry = (type) => (inquiry) => {
  inquiry.category = inquiry.type
  inquiry.type = type
  inquiry.timestamp = inquiry.date
  inquiry.date = moment.unix(inquiry.date).format('DD/MM/YYYY')
  return inquiry
}

export const toPayment = (payment) => {
  return {
    paid: payment.paid,
    advance: payment.advancePrice,
    unpaid: payment.unpaidPrice,
    total: payment.total,
    balance: payment.balance
  }
}



// WEBPACK FOOTER //
// ./src/api/inquiries/adapters.js